import React from 'react'

import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useSelector } from 'react-redux'

import { CreateOrderRequestDto } from '@sparling/financial-common'

import { Modal } from '../../../../../components/Dashboard/Modal'
import { formatInstrumentLabel } from '../../../../../utils/formatInstrument'
import capitalizeFirstLetter from '../../../../../utils/capitalizeFirstLetter'
import { currentInstrumentSelector, currentPriceSelector } from '../../../../../store/selectors'

const useStyles = makeStyles((theme: Theme) => ({
  box: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1),
    minWidth: 340,
  },
  row: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontSize: 16,
    flex: 1,
  },
  value: {
    fontSize: 16,
    flex: 1,
    textAlign: 'right',
  },
  divider: {
    marginBottom: theme.spacing(1),
    background: '#E9ECEF',
    opacity: 0.38,
  },
}))

interface TradingFormConfirmationModalProps {
  open: boolean
  data: CreateOrderRequestDto | null
  onConfirm: () => void
  onCancel: () => void
}

export const TradingFormConfirmationModal: React.FC<TradingFormConfirmationModalProps> = ({
  open,
  data,
  onConfirm,
  onCancel,
}) => {
  const classes = useStyles()
  const currentAsset = useSelector(currentInstrumentSelector)
  const currentPrice = useSelector(currentPriceSelector)

  if (!currentAsset || !currentPrice) {
    return null
  }

  const formattedAsset = formatInstrumentLabel(currentAsset?.underlier)
  const baseCurrency = currentAsset?.underlier ? currentAsset?.underlier.slice(0, 3) : ''
  const quoteCurrency = currentAsset?.underlier ? currentAsset?.underlier.slice(3) : ''

  return (
    <Modal
      isOpen={open}
      modalClose={onCancel}
      title="Review and Execute"
      isSubmit
      onSubmit={onConfirm}
      submitTitle="Confirm"
      cancelTitle="Cancel"
      width={400}
    >
      <Box className={classes.box}>
        {data && (
          <>
            <div className={classes.row}>
              <span className={classes.label}>Instrument</span>
              <span className={classes.value}>{formattedAsset}</span>
            </div>

            <div className={classes.row}>
              <span className={classes.label}>Direction</span>
              <span className={classes.value}>{capitalizeFirstLetter(data.side)}</span>
            </div>

            <div className={classes.row}>
              <span className={classes.label}>Quantity</span>
              <span className={classes.value}>
                {data.quantity} {baseCurrency}
              </span>
            </div>

            <div className={classes.row}>
              <span className={classes.label}>Price</span>
              <span className={classes.value}>
                {data.price} {quoteCurrency}
              </span>
            </div>

            <div className={classes.row}>
              <span className={classes.label}>Amount</span>
              <span className={classes.value}>
                {Number(data.amount).toFixed(2)} {quoteCurrency}
              </span>
            </div>
          </>
        )}
      </Box>
    </Modal>
  )
}
